import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableRow, TableCell, Box, Tooltip, Modal } from '@mui/material';
// import { More } from '../More';
import { getMailingColorStatus } from '../../../mailing/constants';
import { useHistory } from 'react-router-dom';
import { getRouteWithParam, ROUTE_FOR_ASSETS, ROUTES } from '../../../../constants/routes';
import { DISABLED_CONTROL_TOOLTIP } from '../../../../constants/variables';
import { More } from './More';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  outline: 'none'
};

export const PackagesTableBody = ({ data }) => {
  const history = useHistory();
  const [tooltip, setTooltip] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const tableRow = (component, key) =>
    tooltip ? (
      <Tooltip key={key} title={DISABLED_CONTROL_TOOLTIP} arrow data-testid="Tooltip">
        {component}
      </Tooltip>
    ) : (
      component
    );

  const navigateToPartnersDetailPage = (id) =>
    history.push(getRouteWithParam(ROUTES.PARTNERS_EDIT_PACKAGE, ':id', id));

  return (
    <>
      <TableBody data-testid="TableBody">
        {data?.map((item) =>
          tableRow(
            <TableRow
              key={item.id}
              data-testid="TableRow"
              onClick={() => {
                localStorage.setItem('partnersTab', 'PACKAGES');
                navigateToPartnersDetailPage(item.id);
              }}
              onMouseLeave={() => setTooltip(false)}>
              <TableCell>
                <Box width="100px">{item.id}</Box>
              </TableCell>

              <TableCell sx={{ width: 180, maxWidth: 180 }}>
                <Box
                  data-testid="PackageName"
                  sx={{
                    width: 180,
                    maxWidth: 180,
                    whiteSpace: 'normal',
                    overflowWrap: 'anywhere',
                    wordBreak: 'break-word'
                  }}>
                  {item.data.name.ru}
                </Box>
              </TableCell>

              <TableCell sx={{ width: 180, maxWidth: 180 }}>
                <Box
                  sx={{
                    width: 180,
                    maxWidth: 180,
                    whiteSpace: 'normal',
                    overflowWrap: 'anywhere',
                    wordBreak: 'break-word'
                  }}>
                  {item.data.code}
                </Box>
              </TableCell>

              <TableCell>
                <Box width="250px" sx={{ display: 'flex' }}>
                  <img
                    style={{ width: 150, height: 100, objectFit: 'contain', display: 'block' }}
                    src={`${ROUTE_FOR_ASSETS}/api/v1/cms-loyalty/api/bonuses/packages/file/${item?.data.banner.ru}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowModal(item?.data.banner.ru);
                    }}
                  />
                </Box>
              </TableCell>

              <TableCell>
                <Box color={`${getMailingColorStatus(item.status)}`}>{item.status}</Box>
              </TableCell>

              <TableCell onClick={(e) => e.stopPropagation()}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <More
                    id={item.id}
                    status={item.status}
                  />
                </Box>
              </TableCell>
            </TableRow>,
            item.id
          )
        )}
      </TableBody>
      <Modal open={!!showModal} onClose={() => setShowModal(false)}>
        <Box sx={style}>
          <img
            style={{ width: '100%' }}
            src={`${ROUTE_FOR_ASSETS}/api/v1/cms-loyalty/api/bonuses/packages/file/${showModal}`}
          />
        </Box>
      </Modal>
    </>
  );
};

PackagesTableBody.propTypes = {
  data: PropTypes.array,
  openModal: PropTypes.func,
  setCurID: PropTypes.func,
  permissions: PropTypes.object
};
